/* global google */
// ToDo: Refactor this file.
import React from "react";
import autobanco from "../../../assets/img/autobanco.svg";
import autobancoFeatured from "../../../assets/img/autobanco-featured.svg";
import sucursalDigital from "../../../assets/img/sucursal-digital.svg";
import sucursalDigitalFeatured from "../../../assets/img/sucursal-digital-featured.svg";
import atm from "../../../assets/img/atm.svg";
import atmFeatured from "../../../assets/img/atm-featured.svg";
import agencia from "../../../assets/img/agencia.svg";
import agenciaFeatured from "../../../assets/img/agencia-featured.svg";
import kiosko from "../../../assets/img/kiosko.svg";
import kioskoFeatured from "../../../assets/img/kiosko-featured.svg";
import cargadorElectrico from "../../../assets/img/estacion-de-carga.svg";
import servicioCajas from "../../../assets/img/servicio-cajas.svg";
import seleccionAutobanco from "../../../assets/img/selected-autobanco.svg";
import seleccionAutobancoFeatured from "../../../assets/img/selected-autobanco-featured.svg";
import seleccionAtm from "../../../assets/img/selected-atm.svg";
import seleccionAtmFeatured from "../../../assets/img/selected-atm-featured.svg";
import seleccionAgencia from "../../../assets/img/selected-agencia.svg";
import seleccionAgenciaFeatured from "../../../assets/img/selected-agencia-featured.svg";
import seleccionKiosko from "../../../assets/img/selected-kiosko.svg";
import seleccionKioskoFeatured from "../../../assets/img/selected-kiosko-featured.svg";
import formatSchedule from "../Global/formatSchedule";
import getIfOpen from "../Global/getIfOpen";
import getPostalAbbreviation from "../Global/getPostalAbbreviation";
import addQueryParams from "../Global/addQueryParams";
import { Marker } from "google-maps-react";

const Markers = (updateCurrentPopup, markers, currentBranch, updateCurrentBranch, langcode) => {
  const currentBranchImage = (marker,idx) =>{
    if(currentBranch === `${marker.entityLabel.toLowerCase().replace(/ /g, '')}-${idx.toString()}`){
      return marker.selectedIcon
    }else {
      return marker.icon
    }
  }
  const displayMarkers = () => {
    return markers.map((item) => {
      const branchType = item.fieldOfficeBranchType || null;
      if (branchType) {
        switch (branchType) {
          case "RAPIBAC":
          case "RAPIBANCO":
          case "KIOSKO":
            if (item.fieldFeatured) {
              item['icon'] = kioskoFeatured;
              item['selectedIcon'] = seleccionKioskoFeatured;
            } else {
              item['icon'] = kiosko;
              item['selectedIcon'] = seleccionKiosko;
            }
            break;
          case "SUCURSALDIGITAL":
            if (item.fieldFeatured) {
              item['icon'] = sucursalDigitalFeatured;
              item['selectedIcon'] = seleccionAgenciaFeatured;
            } else {
              item['icon'] = sucursalDigital;
              item['selectedIcon'] = seleccionAgencia;
            }
            break;
          case "ATM":
          case "ATMFULL":
          case "ATMFULLCHEQUE":
            if (item.fieldFeatured) {
              item['icon'] = atmFeatured;
              item['selectedIcon'] = seleccionAtmFeatured;
            } else {
              item['icon'] = atm;
              item['selectedIcon'] = seleccionAtm;
            }
            break;
          case "SERVICIODECAJA":
          case "PUNTOS":
          case "EXTRA":
          case "CAJASEMPRESARIALES":
          case "AGENCIA" || "AGENCIAREFORMADOR":
          case "AGENCIAREFORMADOR":
            if (item.fieldFeatured) {
              item['icon'] = agenciaFeatured;
              item['selectedIcon'] = seleccionAgenciaFeatured;
            } else {
              item['icon'] = agencia;
              item['selectedIcon'] = seleccionAgencia;
            }
            break;
          case "AUTOBANCO":
            if (item.fieldFeatured) {
              item['icon'] = autobancoFeatured;
              item['selectedIcon'] = seleccionAutobancoFeatured;
            } else {
              item['icon'] = autobanco;
              item['selectedIcon'] = seleccionAutobanco;
            }
            break;
        }
      } else {
        item['icon'] = servicioCajas;
        item['selectedIcon'] = servicioCajas;
      }
      return item;
    });
  }
  return (
    displayMarkers().reverse().map((marker, idx) => {
      const formatedDate = formatSchedule(marker.fieldSchedule);
      const formatedCounterDate = formatSchedule(marker.fieldScheduleCounter);
      let scheduleState = getIfOpen(formatedDate.currentDate, null, formatedDate.otherDaysOpen);
      let scheduleCounterState = getIfOpen(formatedCounterDate.currentDate, null, formatedCounterDate.otherDaysOpen);
      let branchScheduleState = '';
      if (scheduleState === 'Abierto' || scheduleCounterState === 'Abierto') {
        branchScheduleState = 'Abierto';
      } else if (scheduleState === 'NotFound' && scheduleCounterState === 'NotFound') {
        branchScheduleState = 'NotFound';
      } else {
        branchScheduleState = 'Cerrado';
      };
      const closeMarkerPoint = marker.fieldElectricCharger? new google.maps.Point(40, 40) : new google.maps.Point(30, 30);
      const openAnchorPoint = marker.fieldElectricCharger? new google.maps.Point(58, 64) : new google.maps.Point(48, 54);
      const openScaledSize = marker.fieldElectricCharger? new google.maps.Size(64, 64) : new google.maps.Size(64, 64);
      const closeMarkerSize = marker.fieldElectricCharger? new google.maps.Size(40, 40) : new google.maps.Size(30, 30);
      const markerIndex = marker.fieldFeatured ? 1000 + idx : idx;
      return (
        <Marker
          key={`marker-${idx.toString()}`}
          name={marker.entityLabel}
          zIndex={markerIndex}
          optimized={false}
          onClick={(e) => {
            const type = marker.fieldOfficeBranchType || null;
            // ToDo: This and cardlist option should point to the ID inside the branches variables, pick the one related and use those values.
            updateCurrentPopup({
              entityId: marker.entityId,
              entityLabel: marker.entityLabel,
              fieldAddress: marker.fieldAddress,
              fieldSchedule: formatedDate,
              fieldScheduleCounter: formatedCounterDate,
              queryFieldServices: marker.queryFieldServices,
              fieldCoordinates: marker.fieldCoordinates,
              fieldOfficeBranchType: type,
              image: marker.fieldOfficeBranchImage,
              deactivateSchedule: marker.fieldDesactivarHorario,
              aditionalInfo: marker.fieldDisclamer,
              deactivatePhone: marker.fieldDesactivarTelefono,
              mobilePhone: marker.fieldMobilePhone,
              principalPhone: marker.fieldPrincipalPhone,
              geographyLocation: marker[`fieldGeographyLocation${getPostalAbbreviation(langcode)}`],
              fieldLocation: marker.fieldLocation,
              fieldEnableBranchAppointments: marker.fieldEnableBranchAppointments,
              branchScheduleState,
              hasElectricCharger: marker.fieldElectricCharger
            })
            updateCurrentBranch(e.id);
            addQueryParams({
              "nombre-sucursal": marker.entityLabel,
              "id-sucursal": marker.entityId
            });
          }}
          id={`${marker.entityLabel.toLowerCase().replace(/ /g, '')}-${idx.toString()}`}
          position={{
            lat: marker.fieldCoordinates.lat,
            lng: marker.fieldCoordinates.lng
          }}
          icon={{
            url: marker.fieldElectricCharger? cargadorElectrico :currentBranchImage(marker,idx),
            anchor: currentBranch === `${marker.entityLabel.toLowerCase().replace(/ /g, '')}-${idx.toString()}` ? openAnchorPoint : closeMarkerPoint,
            scaledSize: currentBranch === `${marker.entityLabel.toLowerCase().replace(/ /g, '')}-${idx.toString()}` ? openScaledSize :  closeMarkerSize
          }}
        />
      )
    })
  );
};

export default Markers;
